(() => {
  'use strict';

  const formatImportedName = (value) => {
    const match = String(value || '').trim().match(/^([^,]+),\s*(.+)$/);
    return match ? `${match[2].trim()} ${match[1].trim()}` : String(value || '').trim();
  };

  const productHandleFromCard = (card) => {
    const href = card?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const canonicalProductHandle = (handle) => ({
    'deborah-campert-campert': 'deborah-campert-de-bloem',
    
  }[handle] || handle);

  let productCatalogPromise;
  const productCatalog = () => {
    if (productCatalogPromise) return productCatalogPromise;
    const root = window.Shopify?.routes?.root || '/';
    productCatalogPromise = (async () => {
      const products = [];
      for (let page = 1; page <= 10; page += 1) {
        const response = await fetch(`${root}products.json?limit=250&page=${page}`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Shopify producten: ${response.status}`);
        const batch = (await response.json()).products || [];
        products.push(...batch);
        if (batch.length < 250) break;
      }
      return new Map(products.map((product) => [product.handle, product]));
    })();
    return productCatalogPromise;
  };

  const setupMakerOverview = async (root) => {
    if (root.dataset.mbV125Makers === 'true') return;
    root.dataset.mbV125Makers = 'true';

    root.querySelectorAll('.mb-author-head h3, .mb-illustrator-head h3').forEach((heading) => {
      const oldName = heading.textContent.trim();
      const newName = formatImportedName(oldName);
      if (!newName || newName === oldName) return;
      heading.textContent = newName;
      const block = heading.closest('.mb-author-block, .mb-illustrator-block');
      block?.querySelectorAll('[aria-label], img[alt]').forEach((node) => {
        if (node.hasAttribute('aria-label')) node.setAttribute('aria-label', node.getAttribute('aria-label').replaceAll(oldName, newName));
        if (node.hasAttribute('alt')) node.setAttribute('alt', node.getAttribute('alt').replaceAll(oldName, newName));
      });
    });

    try {
      const products = await productCatalog();
      root.querySelectorAll('.mb-book-card[href*="/products/"]').forEach((card) => {
        const originalHandle = productHandleFromCard(card);
        const productHandle = canonicalProductHandle(originalHandle);
        const product = products.get(productHandle);
        const primary = product?.images?.[0];
        const image = card.querySelector('.mb-book-image img');
        if (!image || !primary?.src) return;
        if (originalHandle !== productHandle) card.href = `${window.Shopify?.routes?.root || '/'}products/${productHandle}`;
        image.dataset.mbShopifyPrimary = 'true';
        image.removeAttribute('srcset');
        image.removeAttribute('data-src');
        image.removeAttribute('data-fallbacks');
        image.removeAttribute('onerror');
        image.onerror = null;
        image.src = primary.src;
        image.alt = primary.alt || image.alt || product.title;
        image.closest('.mb-book-image')?.classList.remove('is-missing');
      });
    } catch (error) {
      console.error('MatchBoox makersafbeeldingen konden niet worden bijgewerkt.', error);
    }
  };

  const setupMobileMakerCarousel = (section) => {
    if (!window.matchMedia('(max-width: 749px)').matches) {
      section.querySelectorAll('.mb-v125-maker-arrow').forEach((button) => button.remove());
      delete section.dataset.mbV125Carousel;
      return;
    }
    if (section.dataset.mbV125Carousel === 'true') return;
    const track = section.querySelector('.mb40__author-grid');
    if (!track || track.children.length < 2) return;
    section.dataset.mbV125Carousel = 'true';

    const makeButton = (direction, label) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `mb-v125-maker-arrow mb-v125-maker-arrow--${direction}`;
      button.setAttribute('aria-label', label);
      button.textContent = direction === 'prev' ? '‹' : '›';
      return button;
    };
    const previous = makeButton('prev', 'Vorige maker');
    const next = makeButton('next', 'Volgende maker');
    section.append(previous, next);

    const currentIndex = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const update = () => {
      const index = currentIndex();
      previous.disabled = index <= 0;
      next.disabled = index >= track.children.length - 1;
    };
    const go = (step) => {
      track.scrollTo({ left: (currentIndex() + step) * track.clientWidth, behavior: 'smooth' });
      window.setTimeout(update, 280);
    };
    previous.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('.mb-page-content[data-page-handle="auteurs"], .mb-page-content[data-page-handle="illustratoren"], .mb-page-content[data-page-handle="vormgevers"]')
      .forEach(setupMakerOverview);
    scope.querySelectorAll?.('.section-matchboox-home .mb40__popular-authors, .section-matchboox-home .mb40__popular-illustrators')
      .forEach(setupMobileMakerCarousel);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  window.addEventListener('resize', () => init(), { passive: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
